<div class="page-container">
    <div class="page-header">
        <button class="btn-back" (click)="location.back()">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Customers</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit Customer' : 'New Customer Registration' }}</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update customer information and branches' : 'Add a new customer to your business network' }}</p>
        </div>
    </div>

    <div class="form-card" [class.loading]="isLoading">
        <!-- Loading Overlay -->
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">Processing...</p>
        </div>
        <!-- Company Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>business</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Company Information</h2>
                    <p>Basic details about the customer</p>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Company / Customer Name</label>
                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [(ngModel)]="nameValue" placeholder="Enter company or customer name" />
                </mat-form-field>
            </div>
        </div>

        <!-- Branch Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>store</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Pickup Name and  Address</h2>
                    <p>Add branches and contact details</p>
                </div>
            </div>

            <!-- Existing Branches Table -->
            <div *ngIf="branches.length > 0" class="branches-table-container">
                <div class="table-header-label">
                    <mat-icon>list</mat-icon>
                    <span>Existing Pickup Locations ({{ branches.length }})</span>
                </div>
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Contact Name</th>
                            <th>Contact Number</th>
                            <th>Pickup Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of branches; let i = index" class="table-row"
                            [class.selected-row]="selectedBranchIndex === i"
                            (click)="onBranchRowClick(data, i)">
                            <td>{{ data.contacts && data.contacts[0] ? data.contacts[0].contactName : '—' }}</td>
                            <td>{{ data.contacts && data.contacts[0] ? (data.contacts[0].phoneNumber | phoneFormat) : '—' }}</td>
                            <td>{{ data.address || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Add/Edit Branch Form -->
            <div class="branch-form-container">
                <div class="branch-form-header">
                    <mat-icon>add_location</mat-icon>
                    <span>{{ selectedBranchIndex >= 0 ? 'Edit Pickup Location' : 'Add New Pickup Location' }}</span>
                </div>

                <div class="form-group">
                    <label class="form-label">Pickup Address</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">location_on</mat-icon>
                        <input matInput [(ngModel)]="address" placeholder="Enter pickup address" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Contact Information</label>
                    <div class="contacts-list">
                        <div *ngFor="let contact of contacts; let i = index" class="contact-row">
                            <div class="contact-badge" *ngIf="i === 0">Primary</div>
                            <div class="contact-fields">
                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">person</mat-icon>
                                    <input matInput [(ngModel)]="contact.name" placeholder="Contact name" />
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">phone</mat-icon>
                                    <input matInput [(ngModel)]="contact.phone" placeholder="Phone number" appPhoneFormat />
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="contact-field">
                                    <mat-icon matPrefix class="field-icon">work</mat-icon>
                                    <input matInput [(ngModel)]="contact.position" placeholder="Position" />
                                </mat-form-field>
                            </div>
                            <button *ngIf="contacts.length > 1" type="button" class="contact-btn contact-btn-remove"
                                (click)="removeContact(i)">
                                <mat-icon>remove</mat-icon>
                            </button>
                        </div>
                        <button type="button" class="contact-btn-add-new" (click)="addContact()">
                            <mat-icon>add</mat-icon>
                            <span>Add Contact</span>
                        </button>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Location on Map</label>
                    <div class="map-container">
                        <app-google-map [height]="'250px'" [location]="currentLocation" (mapClick)="handleMapClick($event)"
                            (locationChanged)="handleLocationChanged($event)"></app-google-map>
                    </div>
                </div>

                <div class="branch-actions">
                    <button type="button" class="btn-secondary" (click)="addBranchBtnAction()">
                        <mat-icon>add_business</mat-icon>
                        <span>Add Branch</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Business Details Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>description</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Business Details</h2>
                    <p>Additional business information</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Business Type</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="businessSelectedValue" placeholder="Select business type">
                            <mat-option *ngFor="let option of businessOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">VAT Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="vatNumber" placeholder="Enter VAT number" />
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Years in Business</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="expertise" [matDatepicker]="pickupPicker" placeholder="Select date">
                        <mat-datepicker-toggle matIconSuffix [for]="pickupPicker"></mat-datepicker-toggle>
                        <mat-datepicker #pickupPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Credit Term</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="creditTermInvoiceSelectedValue" placeholder="Select invoice date">
                            <mat-option *ngFor="let option of creditTermInvoiceOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Financial Rating</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="financialRatingSelectedValue" placeholder="Select rating">
                            <mat-option *ngFor="let option of financialRatingOptions" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Remark</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="remark" placeholder="Enter any remarks" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
            <button type="button" class="btn-cancel" (click)="location.back()">
                Cancel
            </button>
            <button type="submit" class="btn-primary" (click)="submitButtonAction()">
                <mat-icon>{{ isEdit === 'true' ? 'save' : 'add_business' }}</mat-icon>
                <span>{{ isEdit === 'true' ? 'Update Customer' : 'Register Customer' }}</span>
            </button>
        </div>
    </div>
</div>
